import apiClient from "./client";

export interface GetCoordinatesData {
    address?: string;
    city: string;
    zipCode: string;
    country: string;
    palType?: 'LivePal' | 'GearPal';
}

export interface GetCoordinatesResponse {
    message: string;
    data: {
        lat: number;
        lng: number;
    };
}

export const getCoordinates = async (GetCoordinatesData: GetCoordinatesData, language: string) : Promise<GetCoordinatesResponse> => {
    const user = localStorage.getItem('user-storage')
    const parsedUser = user ? JSON.parse(user) : null
    const headers = parsedUser && parsedUser?.state?.user?.access_token ? {
        'Authorization': `Bearer ${parsedUser.state.user.access_token}`,
        'Accept-Language': language
    } : {
        'Accept-Language': language
    }
    const response = await apiClient.post('/geo/get-coordinates', GetCoordinatesData, {
        headers: headers
    });
    return response.data;
}